import { z } from "zod";
import { dateOrFalse } from "./dateOrFalse";

export const deletable = z.object({ deleted: dateOrFalse.default(false) });
